import { api } from 'api'
import { ApiErrors } from 'constants/actionMessages'
import { LoginData } from 'interfaces/api/auth.interfaces'
import { setAxiosAuthorizationToken } from 'modules/axios'
import storage from 'modules/storage'
import { createAction, createAsyncThunk } from 'modules/store'

export const setAuthenticated = createAction<boolean>('profile/setAuthenticated')

export const login = createAsyncThunk('profile/login', async (loginData: LoginData, { rejectWithValue }) =>
  api.auth
    .login(loginData)
    .then((data) => {
      if (!data) {
        return rejectWithValue({
          message: ApiErrors.IncorrectAuth,
          showToast: false,
        })
      }
      storage.setToken(data)
      setAxiosAuthorizationToken(data)
      return data
    })
    .catch((error) => rejectWithValue(error.message)),
)

export const logout = createAction('profile/logout')
